<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.subscribers', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-patient' }" >
                        {{ $t('message.addPatient') }}
                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>


                    <b-container class="justify-content-sm-center">
        <b-row v-if="status == 'SUCCESSFUL'">
            <h2 class="text-center mb-2">Merci d'avoir choisi Medicasure. La solution qui rassure ! Votre opération à reuissi</h2>
        </b-row>
        <b-row v-if="status == 'CANCELED'">
            <h2 class="text-center mb-2">Votre opération n'a pas réuisi ou à été annulé.Vérifiez votre solde et réessayez à nouveau</h2>
            <button class="btn btn-primary primary"  small @click="procederAuPaiement">
                Initier à nouveau le paiement
            </button>
        </b-row>
            </b-container>
        </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: "UbaNotification",

    data(){
        return{
            identifiant:this.$route.params.code,
            status:this.$route.params.status,
        }
    },

    methods:{
        backAddAffiliation(){
            this.$router.push({name:'add-affiliation'});
        },
        procederAuPaiement() {
            this.$router.push({ name: 'paiement', params: { identifiant: this.identifiant } });
        }
    },
    mounted(){
    }

}
</script>

<style scoped>

</style>
